module.exports = __webpack_public_path__ + "img/facebook-icon-white.a27b4904.png";